import { Box, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

export default function PoolListSkeleton(): React.ReactElement {
  return (
    <Paper
      sx={{
        marginTop: 4,
        marginBottom: 4,
        padding: '24px',
        borderRadius: 4,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
        <Skeleton variant="text" width={200} height={40} />
        <Skeleton variant="rectangular" width={120} height={36} />
      </Box>

      <TableContainer sx={{ maxHeight: 800 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '5%' }}></TableCell>
              <TableCell style={{ width: '5%' }}></TableCell>
              <TableCell style={{ width: '45%' }} align="right"></TableCell>
              <TableCell style={{ width: '43%' }} align="left"></TableCell>
              <TableCell style={{ width: '2%' }} align="left"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(5)].map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Skeleton variant="circular" width={30} height={30} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={150} />
                  <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                    <Skeleton variant="rectangular" width={80} height={24} />
                    <Skeleton variant="rectangular" width={80} height={24} />
                  </Box>
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="text" width={100} />
                </TableCell>
                <TableCell align="left">
                  <Skeleton variant="text" width={80} />
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="rectangular" width={80} height={32} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
